<script>
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  name: "LineChart",
  props: {
    filteredData: Object,
  },
  mounted() {
    this.renderChart(this.filteredData.chartData, this.filteredData.options);
  },
  watch: {
    "filteredData.chartData": function () {
      this.renderChart(this.filteredData.chartData, this.filteredData.options);
    },

    "filteredData.graphOptions.startDate": function () {
      this.renderChart(this.filteredData.chartData, this.filteredData.options);
    },
  },
};
</script>